import {
  AccountActionCreators,
  UserContextActionCreators
} from "../../redux/action-creators";
import { useDispatch, useSelector } from "react-redux";

import { AccountDashboardButtonsWrapper } from "./components/AccountDashboardButtonsWrapper";
import ProfileDetails from "../ProfileDetails";
import React from "react";
import { TrackingInfo } from "../tracking/TrackingInfoUserArea";
import { PageContextUtils } from "../../utils";
import { UserContextSelectors } from "../../redux/selectors";
import { useMiniCashierCommunicationHandler } from "../MiniCashier";
import { useAccountCommunicationHandlers } from "../../hooks";
import { AccountDashboardWrapper } from "./AccountDashboardWrapper";
import NotificationBox from "../MyAccountArea/components/NotificationBox/NotificationBox";

const Actions = {
  toggleDrawerState: () => AccountActionCreators.toggleAccountDrawer(),
  toggleMiniCashierDrawerState: () =>
    AccountActionCreators.toggleMiniCashierDrawer(),
  updateBalance: balance => UserContextActionCreators.updateBalance(balance)
};

export const AccountDashboard = () => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const { openCashier } = useMiniCashierCommunicationHandler();
  const dispatch = useDispatch();
  const userIsEligible = useSelector(UserContextSelectors.isEligible);
  const miniCashierEnabled = useSelector(
    UserContextSelectors.miniCashierEnabled
  );
  const { openLogin } = useAccountCommunicationHandlers();

  const { myAccountAreaComponents } = PageContextUtils.getVisualData();

  const handleCashier = async () => {
    if (userIsEligible && miniCashierEnabled) {
      dispatch(Actions.toggleMiniCashierDrawerState());
    } else {
      openCashier({
        Area: "PC Left navigation menu",
        Element: "Plus button",
        Source: "Unified Client",
        AnalyticsData: {
          category: TrackingInfo.dataCategory,
          action: "open deposit",
          label: "Deposit"
        }
      });
    }
  };

  const handleAvatarClick = () => {
    if (isAuthenticated) dispatch(Actions.toggleDrawerState());
    else openLogin();
  };

  return (
    <AccountDashboardWrapper>
      <div className="aCdashbordBox">
        <ProfileDetails
          onProfilePicClick={handleAvatarClick}
          trackingInfo={TrackingInfo}
        />
        <AccountDashboardButtonsWrapper
          handleCashier={handleCashier}
          handleLogin={openLogin}
          trackingInfo={TrackingInfo}
        />
        {!isMobile &&
          myAccountAreaComponents &&
          myAccountAreaComponents.map((comp, index) => {
            const components = {
              NOTIFICATION_BOX: (
                <NotificationBox
                  key={index}
                  properties={comp.properties}
                  trackingInfo={TrackingInfo}
                  height="3.0rem"
                  width="3.0rem"
                />
              )
            };
            return components[comp.id] || null;
          })}
      </div>
    </AccountDashboardWrapper>
  );
};
